module.exports = __webpack_public_path__ + "img/big4-9.27f99a5a.jpg";